import { render, staticRenderFns } from "./ReAssignee.vue?vue&type=template&id=1fbce378&scoped=true&"
import script from "./ReAssignee.vue?vue&type=script&lang=js&"
export * from "./ReAssignee.vue?vue&type=script&lang=js&"
import style0 from "./ReAssignee.vue?vue&type=style&index=0&id=1fbce378&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fbce378",
  null
  
)

export default component.exports